module.exports = __webpack_public_path__ + "static/media/Group 2696.3fc2343b.svg";